var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSwiss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagSwiss_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagSwiss_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagSwiss_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagSwiss_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagSwiss_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6001E",
    d: "M-11 44.112h70.482V3H-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.399 19.702h8.99v-8.995H28.1v8.995h8.99v7.709H28.1v8.99h-7.711v-8.99h-8.99z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iMXJmZG1zdGpqYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSIyaTM0Z3U4NjdiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzFyZmRtc3RqamEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiMxcmZkbXN0amphIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjMmkzNGd1ODY3YikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0M2MDAxRSIgZD0iTTAgNDEuMTEyTDcwLjQ4MiA0MS4xMTIgNzAuNDgyIDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTIyLjM5OSAxNi43MDJMMzEuMzg5IDE2LjcwMiAzMS4zODkgNy43MDcgMzkuMSA3LjcwNyAzOS4xIDE2LjcwMiA0OC4wOSAxNi43MDIgNDguMDkgMjQuNDExIDM5LjEgMjQuNDExIDM5LjEgMzMuNDAxIDMxLjM4OSAzMy40MDEgMzEuMzg5IDI0LjQxMSAyMi4zOTkgMjQuNDExeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagSwiss as ReactComponent };